import React from "react";
import { FilePreview } from "cxa-components";
import { FileUploader } from "../../common/file-uploader";
import { withState } from "recompose";
import { getFileProps } from "cxa-utils";
import { FormField } from "cxa-form-field";
import { ACCEPT_FILES, MAX_FILE_SIZE } from "../../constants";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";

const enhanceWithSurveyDocumentFiles = withState("rejectedFiles", "setRejectedFiles", []);

const renderRejectedFiles = (files = []) =>
  files.length > 0 && (
    <div className="field__error">
      <FormattedMessage {...messages.uploadImageOrPDFLimitationDescription} />
    </div>
  );

const renderDocumentUploader = enhanceWithSurveyDocumentFiles(
  ({
    name,
    value,
    onChange,
    onBlur,
    onDrop,
    rejectedFiles,
    setRejectedFiles,
    meta,
    error,
    flat,
    intl,
    validate,
    ...rest
  }) => {
    const surveyDocuments = value && [].concat(value);

    // Limit the file upload to 1 file
    // Always select the latest file that was uploaded
    const selectLatestFileUploaded = (files = []) => {
      if (files.length > 0) {
        onChange([files[files.length - 1]]);
      } else {
        onChange(files);
      }
    };

    return (
      <div>
        <FileUploader
          accept={ACCEPT_FILES}
          maxSize={MAX_FILE_SIZE}
          multiple={false}
          disabled={false}
          onDrop={(files, rejectedFiles) => {
            selectLatestFileUploaded([...value, ...files]);
            setRejectedFiles(rejectedFiles);
          }}
          {...rest}
        />
        {surveyDocuments.length > 0 &&
          surveyDocuments.map(file => {
            // Pass empty string to remove the file in the state
            // We're only handling 1 file for survey file upload, either with or without file, so this approach should be safe
            const onDelete = () => onChange("");
            const fileProps = getFileProps(file);
            return (
              <FilePreview key={fileProps.name} {...fileProps} onDelete={onDelete} disabled={false} />
            );
          })}
        {!error && meta.dirty && renderRejectedFiles(rejectedFiles)}
      </div>
    );
  }
);

const SurveyDocumentUpload = props => (
  <FormField multiple={false} component={renderDocumentUploader} {...props} />
);

export default SurveyDocumentUpload;



// WEBPACK FOOTER //
// ./components/employee/benefits/SurveyDocumentUpload.js